<template>
    <div class="lottery-page">
        <div class="m-title">
            <div style="display: flex;height: 70px;align-items: center;">
                <van-icon @click="back" style="margin-right: 15px;" name="arrow-left" size="25"/>
                福利抽奖
            </div>
        </div>

        <div class="lottery-container">
            <div class="lottery-header">
                <h2 class="lottery-title">幸运抽奖</h2>
                <p class="lottery-desc">免费抽奖，赢取丰厚福利</p>
            </div>

            <div class="lottery-grid">
                <div 
                    v-for="index in 9" 
                    :key="index - 1"
                    class="grid-item"
                    :class="{ 
                        active: currentIndex === (index - 1) && isSpinning,
                        winner: !isSpinning && winnerIndex === (index - 1),
                        center: index === 5 
                    }"
                >
                    <template v-if="index === 5">
                        <div class="center-btn" @click="startLottery" :class="{ disabled: isSpinning || !isLogin }">
                            <span>{{ isSpinning ? '抽奖中...' : '开始抽奖' }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <span class="prize-value">{{ getPrize(index - 1) }}</span>
                        <span class="prize-unit">充值</span>
                    </template>
                </div>
            </div>

            <div v-if="showResult" class="result-popup" @click.self="closeResult">
                <div class="result-content">
                    <van-icon name="gift" size="60" color="#f55050"/>
                    <h3 class="result-title">恭喜获得</h3>
                    <p class="result-value">{{ winPrize }} 充值</p>
                    <van-button type="primary" @click="closeResult">确定</van-button>
                </div>
            </div>

            <div class="lottery-info">
                <div class="info-item">
                    <span class="info-label">剩余次数</span>
                    <span class="info-value">{{ remainingTimes }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">累计获得</span>
                    <span class="info-value total">{{ totalWon }} 充值</span>
                </div>
            </div>

            <div class="lottery-rules">
                <h4 class="rules-title">抽奖规则</h4>
                <ul class="rules-list">
                    <li>每个账号仅可抽奖一次</li>
                    <li>获得的充值联系客服提供信息领取</li>
                </ul>
            </div>

            <div class="customer-service">
                <button class="service-btn" @click="goToService">
                    <span class="service-icon">💬</span>
                    <span class="service-text">在线客服</span>
                </button>
            </div>
        </div>

        <div class="me-login-view" v-if="showLogin" @click.self="showLogin = false">
            <home-login @login-success="handleLoginSuccess"></home-login>
        </div>

        <home-tabbar></home-tabbar>
    </div>
</template>

<script>
    import {request, webTokenRequest} from "@/api/request";
    import homeNav from "@/components/HomeNav";
    import homeTabbar from "@/components/HomeTabbar";
    import HomeLogin from "@/components/HomeLogin.vue";
    import {Toast} from "vant";

    export default {
        name: "Lottery",
        components: {
            homeNav,
            homeTabbar,
            HomeLogin
        },
        data() {
            return {
                isLogin: false,
                showLogin: false,
                isSpinning: false,
                showResult: false,
                winPrize: 0,
                remainingTimes: 1,
                totalWon: 0,
                currentIndex: -1,
                winnerIndex: -1,
                prizes: [500, 700, 900, 1200, 1500, 1800, 2100, 2500]
            }
        },
        computed: {
            displayPrizes() {
                return this.prizes;
            }
        },
        mounted() {
            this.checkLoginStatus();
            this.loadLotteryInfo();
        },
        methods: {
            back() {
                this.$router.back();
            },
            getPrize(index) {
                if (index < 4) {
                    return this.prizes[index];
                } else {
                    return this.prizes[index - 1];
                }
            },
            checkLoginStatus() {
                let webToken = localStorage.getItem('web_token');
                this.isLogin = !!webToken;
            },
            loadLotteryInfo() {
                if (!this.isLogin) return;
                
                let options = {
                    url: "/web/getLotteryInfo",
                    method: 'get'
                };
                webTokenRequest(options).then(res => {
                    if (res.data.success) {
                        let data = res.data.data;
                        this.remainingTimes = data.remainingTimes !== undefined ? data.remainingTimes : 3;
                        this.totalWon = data.totalWon !== undefined ? data.totalWon : 0;
                    }
                }).catch(() => {
                    // 默认值
                });
            },
            handleLoginSuccess() {
                this.showLogin = false;
                this.isLogin = true;
                this.loadLotteryInfo();
            },
            startLottery() {
                if (!this.isLogin) {
                    this.showLogin = true;
                    return;
                }
                
                if (this.isSpinning) return;
                
                if (this.remainingTimes <= 0) {
                    Toast('您已抽过奖');
                    return;
                }

                this.isSpinning = true;
                this.showResult = false;
                this.winnerIndex = -1;
                this.currentIndex = 0;

                let options = {
                    url: "/web/drawLottery",
                    method: 'post'
                };
                
                webTokenRequest(options).then(res => {
                    if (res.data.success) {
                        const { remainingTimes, prizeIndex, prizeAmount } = res.data.data;
                        
                        this.remainingTimes = remainingTimes !== undefined ? remainingTimes : 0;
                        const winnerGridIndex = prizeIndex;

                        const getPrizeStepIndex = (gridIndex) => {
                            const indexMap = { 0: 0, 1: 1, 2: 2, 5: 3, 8: 4, 7: 5, 6: 6, 3: 7 };
                            return indexMap[gridIndex];
                        };

                        const winnerStepIndex = getPrizeStepIndex(prizeIndex);
                        let totalSteps = 32 + winnerStepIndex;
                        let step = 0;
                        let speed = 80;

                        const getGridIndex = (stepIndex) => {
                            const validIndices = [0, 1, 2, 5, 8, 7, 6, 3];
                            return validIndices[stepIndex % 8];
                        };

                        const animate = () => {
                            if (step < totalSteps) {
                                this.currentIndex = getGridIndex(step);
                                
                                if (step > totalSteps - 8) {
                                    speed += 15;
                                } else if (step < 8) {
                                    speed = 60;
                                }
                                
                                step++;
                                setTimeout(animate, speed);
                            } else {
                                this.winnerIndex = winnerGridIndex;
                                this.winPrize = prizeAmount;
                                this.isSpinning = false;
                                
                                setTimeout(() => {
                                    this.showResult = true;
                                    this.totalWon += prizeAmount;
                                }, 500);
                            }
                        };

                        animate();
                    } else {
                        this.isSpinning = false;
                        Toast(res.data.message || '抽奖失败');
                    }
                }).catch((error) => {
                    this.isSpinning = false;
                    const errorMsg = error?.response?.data?.message || 
                                     error?.message || 
                                     '抽奖失败，请稍后重试';
                    Toast(errorMsg);
                });
            },
            goToService() {
                this.$router.push('/home/kf');
            },
            closeResult() {
                this.showResult = false;
                this.winnerIndex = -1;
            }
        }
    }
</script>

<style scoped>
    .lottery-page {
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        display: flex;
        flex-direction: column;
    }

    .m-title {
        display: flex;
        font-size: 20px;
        color: #ffffff;
        width: 100%;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }

    .lottery-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 10px;
        max-width: 420px;
        margin: 0 auto;
        width: 100%;
        box-sizing: border-box;
        overflow: auto;
        margin-top: 80px;
    }

    .lottery-header {
        text-align: center;
        color: #ffffff;
        margin-bottom: 10px;
        flex-shrink: 0;
        padding-top: 15px;
    }

    .lottery-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 3px;
    }

    .lottery-desc {
        font-size: 11px;
        opacity: 0.8;
    }

    .lottery-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        max-width: 240px;
        width: 100%;
        margin: 0 auto 10px;
        flex-shrink: 0;
    }

    .grid-item {
        aspect-ratio: 1;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        transition: all 0.2s;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .grid-item.active {
        background: linear-gradient(135deg, #f55050 0%, #ff7a7a 100%);
        transform: scale(1.08);
        box-shadow: 0 6px 20px rgba(245, 80, 80, 0.6);
    }

    .grid-item.active .prize-value,
    .grid-item.active .prize-unit {
        color: #ffffff;
    }

    .grid-item.winner {
        background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
        animation: winnerPulse 1s infinite;
    }

    @keyframes winnerPulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }

    .grid-item.center {
        background: linear-gradient(135deg, #f55050 0%, #ff7a7a 100%);
        box-shadow: 0 6px 20px rgba(245, 80, 80, 0.5);
    }

    .prize-value {
        font-size: 18px;
        font-weight: bold;
        color: #f55050;
        line-height: 1.2;
    }

    .prize-unit {
        font-size: 11px;
        color: #666;
        margin-top: 2px;
    }

    .center-btn {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 12px;
        transition: all 0.2s;
    }

    .center-btn:active:not(.disabled) {
        transform: scale(0.95);
    }

    .center-btn.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .center-btn span {
        color: #ffffff;
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        line-height: 1.3;
    }

    .result-popup {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        animation: fadeIn 0.3s;
        padding: 20px;
        box-sizing: border-box;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .result-content {
        background: #ffffff;
        border-radius: 16px;
        padding: 30px 40px;
        text-align: center;
        animation: bounceIn 0.5s;
        width: 100%;
        max-width: 260px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    }

    @keyframes bounceIn {
        0% { transform: scale(0.5); opacity: 0; }
        70% { transform: scale(1.05); }
        100% { transform: scale(1); opacity: 1; }
    }

    .result-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin: 12px 0 8px;
    }

    .result-value {
        font-size: 28px;
        font-weight: bold;
        color: #f55050;
        margin-bottom: 22px;
    }

    .lottery-info {
        display: flex;
        justify-content: space-around;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        padding: 12px 12px;
        margin-bottom: 10px;
    }

    .info-item {
        text-align: center;
    }

    .info-label {
        display: block;
        font-size: 11px;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 4px;
    }

    .info-value {
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
    }

    .info-value.total {
        color: #ffd700;
    }

    .lottery-rules {
        background: rgba(255, 255, 255, 0.15);
        border-radius: 10px;
        padding: 12px;
        color: #ffffff;
    }

    .rules-title {
        font-size: 12px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: center;
    }

    .rules-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .rules-list li {
        font-size: 11px;
        line-height: 1.6;
        padding-left: 14px;
        position: relative;
        margin-bottom: 3px;
    }

    .rules-list li::before {
        content: '✓';
        position: absolute;
        left: 0;
        color: #ffd700;
        font-size: 10px;
    }

    .customer-service {
        margin-top: 12px;
        padding: 0 10px 10px;
    }

    .service-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 12px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 25px;
        color: #ffffff;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    }

    .service-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
    }

    .service-btn:active {
        transform: translateY(0);
    }

    .service-icon {
        font-size: 20px;
        margin-right: 8px;
    }

    .service-text {
        font-size: 16px;
    }

    .me-login-view {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
    }

    @media screen and (min-width: 500px) {
        .lottery-grid {
            max-width: 280px;
            gap: 12px;
        }
        .lottery-title {
            font-size: 22px;
        }
        .prize-value {
            font-size: 20px;
        }
        .prize-unit {
            font-size: 12px;
        }
        .center-btn span {
            font-size: 16px;
        }
    }

    @media screen and (min-width: 900px) {
        .lottery-page {
            max-width: 500px;
            margin: 0 auto;
            border-radius: 12px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        }
        .m-title {
            display: flex;
            font-size: 20px;
        }
        .lottery-grid {
            max-width: 300px;
            gap: 14px;
        }
        .lottery-title {
            font-size: 24px;
        }
        .prize-value {
            font-size: 22px;
        }
        .center-btn span {
            font-size: 17px;
        }
    }
</style>